import { paginatedQuery } from 'lib-shared-api-utils';
import {
  CreateCompanyApiArg,
  CreateCompanyApiResponse,
  ReadCompaniesApiArg,
  ReadCompaniesApiResponse,
  ReadCompanyApiArg,
  ReadCompanyApiResponse,
  ReadCompanyRelatedUsersApiArg,
  ReadCompanyRelatedUsersApiResponse,
  UpdateCompanyApiArg,
  UpdateCompanyApiResponse,
} from 'lib-shared-types-api';

import { api } from 'app/app.api';

export const companiesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createCompany: builder.mutation<
      CreateCompanyApiResponse,
      CreateCompanyApiArg
    >({
      query: (data) => ({
        version: 1,
        path: 'companies',
        method: 'POST',
        data,
      }),
    }),
    readCompany: builder.query<ReadCompanyApiResponse, ReadCompanyApiArg>({
      query: ({ id }) => ({
        version: 1,
        path: `companies/${id}`,
      }),
    }),
    readCompanyRelatedUsers: builder.query<
      ReadCompanyRelatedUsersApiResponse,
      ReadCompanyRelatedUsersApiArg
    >({
      query: (arg) =>
        paginatedQuery(arg, ({ id }) => ({
          version: 1,
          path: `companies/${id}/users`,
        })),
    }),
    updateCompany: builder.mutation<
      UpdateCompanyApiResponse,
      UpdateCompanyApiArg
    >({
      query: ({ id, patch: body }) => ({
        version: 1,
        path: `companies/${id}`,
        method: 'PATCH',
        body,
      }),
    }),
    readCompanies: builder.query<ReadCompaniesApiResponse, ReadCompaniesApiArg>(
      {
        query: ({ limit }) => ({
          version: 1,
          path: 'companies',
          params: {
            limit,
          },
        }),
      },
    ),
  }),
});
